import { create } from "zustand";
import type { Draft } from "@/prisma/generated/client";

type CurrentDraftStore = {
  currentDraft: Draft | null;
  setCurrentDraft: (draftData: Draft | null) => void;
};

export const useCurrentDraftStore = create<CurrentDraftStore>((set) => ({
  currentDraft: null,
  setCurrentDraft: (draftData) => set({ currentDraft: draftData }),
}));
